import * as React from 'react';
import * as Redux from 'redux';

export interface IControlledTextboxProps {
    id: string;
    value: string;
    onInput?: (e: React.FormEvent<HTMLInputElement>) => void;
    onKeyPress?: (e: React.FormEvent<HTMLInputElement>) => void;
    onKeyDown?: (e: React.FormEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FormEvent<HTMLInputElement>) => void;
    onFocus?: (e: React.FormEvent<HTMLInputElement>) => void;
    hasError?: boolean;
    errorText?: string;
    labelText?: string;
    placeHolder?: string;
    customClasses?: string;
    required?: boolean;
}

/// <summary>
/// This class can be used for a textbox with built in styling and handling for the AAP error state.
/// This is an controlled component whose value should be tied to state.
/// For an uncontrolled component, use Textbox instead.
/// </summary>
/// <param name="id">The html id of the textbox. Required to associate the label with the textbox</param>
/// <param name="onInput">The callback function for when the textbox input changes. Current textbox text should be saved in a state variable</param>
/// <param name="hasError">Determines whether or not to show the error state (optional, default=false)</param>
/// <param name="errorText">The error message displayed when the textbox is in its error state (optional, default='')</param>
/// <param name="labelText">The text shown for the label (optional, default='')</param>
/// <param name="defaultValue">Default text to display in the textbox (optional, default='')</param>
/// <param name="placeHolder">Default placeholder text (optional, default='')</param>
/// <param name="customClasses">Used to supply any additional classes to the surrounding textbox div (optional, default='')</param>
/// <returns></returns>
export class ControlledTextbox extends React.Component<IControlledTextboxProps, any> {
    static defaultProps = {
        onInput: () => { },
        onKeyPress: () => { },
        onKeyDown: () => { },
        onFocus: () => { },
        onBlur: () => { },
        hasError: false,
        errorText: '',
        labelText: '',
        defaultValue: '',
        placeHolder: '',
        customClasses: '',
        required: false
    }

    GetClassNames() {
        let FORM_CLASSES = " form-element form-element-required";
        let INVALID_CLASS = " form-element-invalid";
        let classes = this.props.customClasses + FORM_CLASSES;

        if (this.props.hasError)
            classes += INVALID_CLASS;

        return classes;
    }

    onInputHandler(e: React.FormEvent<HTMLInputElement>) {
        this.props.onInput(e);
    }

    onKeyPressHandler(e: any) {
        this.props.onKeyPress(e);
    }

    onKeyDownHandler(e: any) {
        this.props.onKeyDown(e);
    }

    onBlurHandler(e: any) {
        this.props.onBlur(e);
    }

    onFocusHandler(e: any) {
        this.props.onFocus(e);
    }

    render() {
        let boundInput = this.onInputHandler.bind(this);
        let boundKeyPress = this.onKeyPressHandler.bind(this);
        let boundonKeyDown = this.onKeyDownHandler.bind(this);
        let boundOnBlur = this.onBlurHandler.bind(this);
        let boundOnFocus = this.onFocusHandler.bind(this);

        return (
            <div className={this.GetClassNames()}>
                <input className="form-element-input" type="text" id={this.props.id}
                    defaultValue={this.props.value}
                    onInput={boundInput}
                    onKeyDown={boundonKeyDown}
                    onBlur={boundOnBlur}
                    onFocus={boundOnFocus}
                    onKeyPress={boundKeyPress}
                    placeholder={this.props.placeHolder}
                    required={this.props.required} />
                <label className="form-element-label" htmlFor={this.props.id}>
                    <span className="form-element-label-main">{this.props.labelText}</span>
                    {this.props.required ? <span className="form-element-label-sub">Required</span> : null}
                </label>
                <div className="form-element-error">
                    <svg className="form-element-error-icon">
                        <use xlinkHref="#icon-error"></use>
                    </svg>
                    <div className="form-element-error-text">
                        {this.props.errorText}
                    </div>
                </div>
            </div>
        );
    }
}